/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography } from '@mui/material';
import { formatMedicaoPeriodLabel } from './constants';

const PeriodoSectionHeader = ({
  inicio,
  fim,
  lente,
}) => {
  const periodoLabel = formatMedicaoPeriodLabel(inicio, fim);

  return (
    <Stack spacing={0.5}>
      <Typography
        variant="overline"
        color="text.secondary"
        sx={{ letterSpacing: 1, display: 'block' }}
      >
        Meu período
      </Typography>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1}
        alignItems={{ xs: 'flex-start', sm: 'baseline' }}
        flexWrap="wrap"
        useFlexGap
      >
        {periodoLabel && (
          <Typography variant="body2">
            Ciclo {periodoLabel}
          </Typography>
        )}
        {lente?.label && (
          <Typography variant="caption" color="text.secondary">
            {lente.label}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

PeriodoSectionHeader.propTypes = {
  inicio: PropTypes.number,
  fim: PropTypes.number,
  lente: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    unidade: PropTypes.string,
  }),
};

PeriodoSectionHeader.defaultProps = {
  inicio: null,
  fim: null,
  lente: null,
};

export default PeriodoSectionHeader;
